<div
    class="tw:w-full tw:px-6 tw:py-8"
    [class.tw:pb-28]="hasNewItemsInCart() || checkoutMode() === CheckoutMode.INVOICE_REMAINING"
>
    <div class="tw:mb-6">
        @if (checkoutMode() === CheckoutMode.CREATE_FULL_SALE) {
            @if (addPatientOpen()) {
                <app-client-selector (selectedPatient)="selectPatient($event)" />
            } @else {
                <div class="tw:flex tw:items-center tw:justify-between tw:rounded-lg tw:bg-primary-50 tw:p-4">
                    @if (selectedPatient()) {
                        <div>
                            <div class="tw:font-bold tw:text-primary-500">{{ selectedPatient().firstName }} {{ selectedPatient().lastName }}</div>
                            <div class="tw:text-sm">
                                {{ selectedPatient().vatNumber }}
                                @if (canShowClientContacts() && selectedPatient().phoneNumber) {
                                    @if (selectedPatient().vatNumber) {
                                        <span> • </span>
                                    }
                                    {{ selectedPatient().phoneNumber }}
                                }
                            </div>
                        </div>
                        <button type="button" class="btn" (click)="clearPatient()">
                            <i class="material-icons icon tw:text-primary-500" >cancel</i>
                        </button>

                    } @else {
                        <div class="tw:cursor-pointer" (click)="openAddPatient()">
                            <div class="tw:font-bold tw:text-primary-500">{{ "INVOICE_ADD_ITEMS.addPatientTitle" | translate }}</div>
                            <div class="tw:text-sm">{{ "INVOICE_ADD_ITEMS.addPatientDescription" | translate }}</div>
                        </div>
                        <button type="button" class="btn" (click)="openAddPatient()">
                            <i class="material-icons icon tw:text-primary-500" >add_circle</i>
                        </button>
                    }
                </div>
            }
        } @else if (checkoutMode() === CheckoutMode.EDIT_SALE || checkoutMode() === CheckoutMode.INVOICE_REMAINING) {
            @if (selectedPatient()) {
                <div class="tw:flex tw:items-center tw:justify-between tw:rounded-lg tw:bg-primary-50 tw:p-4">
                    <div class="tw:font-bold tw:text-primary-500">{{ selectedPatient().firstName }} {{ selectedPatient().lastName }}</div>
                    <div class="tw:text-sm">
                        {{ selectedPatient().vatNumber }}
                        @if (canShowClientContacts() && selectedPatient().phoneNumber) {
                            @if (selectedPatient().vatNumber) {
                                <span> • </span>
                            }
                            {{ selectedPatient().phoneNumber }}
                        }
                    </div>
                </div>
            }
        }
    </div>

    <h6 class="tw:h6">{{ "INVOICE_ADD_ITEMS.title" | translate }}</h6>

    <div class="tw:pt-6">
        <app-tab-bar [(activeTab)]="activeTab" [tabOptions]="tabOptions" (tabChanged)="onTabChanged($event)" />
    </div>

    <form [formGroup]="filterForm" class="tw:mt-6">
        <app-text-input formControlName="search" icon="search" placeholder="{{ 'INVOICE_ADD_ITEMS.searchPlaceholder' | translate }}" />
    </form>

    @if (loading()) {
        <div class="tw:p-4">
            <app-loader />
        </div>
    } @else {
        @if (activeTab() === "services") {
            <div class="tw:flex tw:flex-col tw:gap-4 tw:py-3">
                @for (service of filteredServices(); let i = $index; track i) {
                    @if (service.category ) {
                        @if (!separatorsWithServices() || separatorsWithServices().includes(service.name)) {
                            <div class="tw:px-4 tw:text-lg tw:font-semibold tw:text-primary-500">
                                {{  service.name }}
                            </div>
                        }
                    } @else {
                        <ng-container *ngTemplateOutlet="itemLine; context: { $implicit: service, type: ItemType.SERVICE }" />

                    }
                }
            </div>
            @if (availableServices()?.length === 0) {
                <div class="text-center py-5 tw:text-neutral-500 tw:text-sm">
                    <i class="material-icons icon tw:text-primary tw:!text-4xl">list</i>
                    <p class="tw:text-primary-300">{{ 'INVOICE_ADD_ITEMS.emptyServicesDescription' | translate }}</p>
                </div>
            }
        } @else if (activeTab() === "products") {
            <div class="tw:flex tw:flex-col tw:gap-4 tw:py-3">
                @for (product of filteredProducts(); let i = $index; track i) {
                    <ng-container *ngTemplateOutlet="itemLine; context: { $implicit: product, type: ItemType.PRODUCT }" />
                }
            </div>
            @if (!filteredProducts().length) {
                <div class="text-center py-5 tw:text-neutral-500 tw:text-sm">
                    <i class="material-icons icon tw:text-primary tw:!text-4xl">list</i>
                    <p class="tw:text-primary-300">{{ 'INVOICE_ADD_ITEMS.emptyProductsDescription' | translate }}</p>
                </div>
            }
        }
    }

</div>
<div class="tw:fixed tw:bottom-0 tw:left-0 tw:right-0 tw:z-10 tw:bg-white tw:px-6 tw:pb-4 tw:pt-2 tw:lg:left-1/2">
    @if (hasNewItemsInCart() || checkoutMode() === CheckoutMode.INVOICE_REMAINING) {
        <button [disabled]="!canContinue()" class="btn btn-md btn-primary tw:w-full" (click)="continue()">
            {{ "GENERAL.continue" | translate }}
            <i class="material-icons icon ml-2" >arrow_forward</i>
        </button>
    }
</div>

<ng-template #itemLine let-item let-type="type">
    <div class="tw:flex tw:items-center tw:justify-between tw:rounded-lg tw:bg-primary-50 tw:p-4">
        <div class="tw:font-bold tw:text-primary-500">{{ item.name }}</div>
        <div class="tw:flex tw:items-center tw:gap-1">
            <span class="tw:text-neutral-500">{{ item.price | merchantCurrency }}</span>
            <button type="button" class="btn" (click)="addItemToCart(item, type)">
                <i class="material-icons icon tw:text-primary-500" >add_circle</i>
            </button>
        </div>
    </div>
</ng-template>
